import React from 'react';
import '../../css/RiderInsight.css';

function RiderDeliveries() {
  return (
    <div className='deliveryContainer'>
        Delivery Logic Here
        </div>
  )
}

export default RiderDeliveries;